/* eslint-disable sort-keys */

import {
  catalogStaticProps,
  optimizeCatalogStaticProps,
} from './static-props/catalog-static-props';
import { contactsStaticProps } from './static-props/contacts-static-props';
import { homeStaticProps } from './static-props/home-static-props';
import { portfolioStaticProps } from './static-props/portfolio-static-props';

/**
 * Export `pageComponents`.
 */

export const pageComponents = {
  home: '',
  portfolio: 'portfolio',
  catalog: 'catalog',
  contacts: 'contacts',
};

/**
 * Export `pageStaticProps`.
 */

export const pageStaticProps = {
  '': homeStaticProps,
  contacts: contactsStaticProps,
  portfolio: portfolioStaticProps,
  catalog: catalogStaticProps,
};

/**
 * Export `optimizeStaticProps`.
 */

export const optimizeStaticProps = {
  default: (data) => data,
  catalog: optimizeCatalogStaticProps,
};
